export default "__VITE_ASSET__B2C3pUKB__"